module.exports = __webpack_public_path__ + "img/widget_v05.91952750.png";